import React from "react";
import PropTypes from "prop-types";
import { AvForm, AvGroup, AvField } from "availity-reactstrap-validation";
import { Col, Label } from "reactstrap";
import { regexTextArea } from "utils/regexExpressions";
import { useTranslation } from "react-i18next";
import cx from "classnames";

const TextArea = (props) => {
  const { t } = useTranslation();
  const {
    id,
    label,
    hide,
    required,
    isPreview,
    minLength,
    maxLength,
    handleOnChangeRecord,
    handleOnKeyPress,
    value,
  } = props;

  let hideLabelTextArea = null;

  /**
   * Conditionally generates a JSX element to hide or show a labeled textarea.
   * @param {boolean} hide - A boolean flag indicating whether to hide the labeled textarea.
   * @param {string} t - A function for translating text labels.
   * @returns {JSX.Element|null} - A JSX element representing a labeled textarea with optional hiding text, or null if 'hide' is false.
   */
  if (hide === true) {
    hideLabelTextArea = <i className="hide-textBox custom-opacity">({t("form.field49")})</i>;
  } else {
    hideLabelTextArea = null;
  }

  if (isPreview === true) {
    return (
      <AvForm row>
        <AvGroup row>
          <Label
            className={cx("", {
              "is-required": required === true,
            })}
            sm={3}
          >
            {label} {hideLabelTextArea}
          </Label>

          <Col md={8}>
            <AvField
              id={id}
              name={id}
              type="textarea"
              key={id}
              validate={{
                required: {
                  value: required,
                  errorMessage: `${t("fieldRequired")}`,
                },
                pattern: {
                  value: regexTextArea,
                  errorMessage: `${t("createRoles.InputInvalid")}`,
                },
                minLength: {
                  value: minLength,
                  errorMessage: `${t("fieldValidateLengthBetween")} ${minLength} ${t(
                    "and"
                  )} ${maxLength} ${t("characters")}`,
                },
                maxLength: {
                  value: maxLength,
                  errorMessage: `${t("fieldValidateLengthBetween")} ${minLength} ${t(
                    "and"
                  )} ${maxLength} ${t("characters")}`,
                },
              }}
              onChange={(e) => handleOnChangeRecord(id, e.target.value)}
              onKeyPress={handleOnKeyPress}
              value={value}
            />
          </Col>
        </AvGroup>
      </AvForm>
    );
  } else if (hide === false) {
    return (
      <AvGroup row>
        <Label
          className={cx("", {
            "is-required": required === true,
          })}
          sm={3}
        >
          {label}
        </Label>
        <Col md={8}>
          <AvField
            id={id}
            name={id}
            type="textarea"
            key={id}
            validate={{
              required: {
                value: required,
                errorMessage: `${t("fieldRequired")}`,
              },
              pattern: {
                value: regexTextArea,
                errorMessage: `${t("createRoles.InputInvalid")}`,
              },
              minLength: {
                value: minLength,
                errorMessage: `${t("fieldValidateLengthBetween")} ${minLength} ${t(
                  "and"
                )} ${maxLength} ${t("characters")}`,
              },
              maxLength: {
                value: maxLength,
                errorMessage: `${t("fieldValidateLengthBetween")} ${minLength} ${t(
                  "and"
                )} ${maxLength} ${t("characters")}`,
              },
            }}
            onChange={(e) => handleOnChangeRecord(id, e.target.value)}
            onKeyPress={handleOnKeyPress}
            value={value}
          />
        </Col>
      </AvGroup>
    );
  } else {
    return null;
  }
};

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hide: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  minLength: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  handleOnChangeRecord: PropTypes.func.isRequired,
  handleOnKeyPress: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default TextArea;
